import { BcFieldProps } from "../../../interface/props/bcfield";
import { BCInput, BCInputCont } from "../../../styled/global.styled";

const InputField = ({field, register, isRequired, errors }: BcFieldProps ) => (
    <BCInputCont className="bc-form-field">
        <BCInput
            id={field.item}
            className="bc-input"
            placeholder={field.placeholder}
            aria-label={field.label}
            type={field.type}
            {...register(field.item, { required: isRequired })}
        />
        <label htmlFor={field.item}>{field.label}</label>
        {errors && <span>Help Text</span>}
    </BCInputCont>
);

export default InputField;